import axios from "../../../axios";
import Cookies from "js-cookie";

export const GetPublishedJobs = async () => {
  const token = Cookies.get("ConsultantToken");

  return axios.post("/api/Consultant/GetPublishedJobs", {
    token,
  });
};



// services/jobService.js
// Author: Harshada Bhavsar (22/7/2025)
// API: Created Job Opening for Consultant
// services/jobService.js
export const getJobDetails = async (jobUID) => {
  const token = Cookies.get("ConsultantToken");
  return axios.post("/api/Consultant/GetJobDetails", {
    token,
    jobUID,
  });
};
